import tipReportApi from "../../api/report/tipReportApi";

export interface TipReportFilter {
    branchId?: number;
    dateFrom: string; // yyyy-MM-dd
    dateTo: string; // yyyy-MM-dd
}

const TipReportService = {

    /** POST /api/reports/tips/search */
    search: async (filter: TipReportFilter) => {
        const response = await tipReportApi.addCustom("/search", filter);
        return response.data;
    },

    /** POST /api/reports/tips/export/pdf */
    exportPdf: async (filter: TipReportFilter) => {
        return await tipReportApi.downloadFileFromBlob("/export/pdf", filter, "propina.pdf");
    },

    /** POST /api/reports/tips/export/excel */
    exportExcel: async (filter: TipReportFilter) => {
        return await tipReportApi.downloadFileFromBlob("/export/excel", filter, "propina.xlsx");
    },

};

export default TipReportService;
